/**
 * UImgSourceResolver — résolution de chemin d'image pour UImg (ha/447).
 *
 * Logique pure : aucune dépendance DOM, juste le `host` (UImg) pour accéder
 * aux clés `src`/`mid`/`imb`/`h`/`w` via get/translate/trans. Permet de tester
 * la résolution sans monter l'éditeur.
 */

export interface UImgSourceHost {
    get(key: string): any;
    translate(value: any): any;
    trans(key: string): any;
}

const SOURCE_TYPE_MEDIA = "media";
const SOURCE_TYPE_STATIC = "static";

export class UImgSourceResolver {
    constructor(private readonly host: UImgSourceHost) {}

    public getImageSrc(): string {
        const src: string = this.host.translate(this.host.get("src"));
        if (src && this.isStaticSource()) {
            return src;
        }

        const mid: string = this.host.translate(this.host.get("mid"));
        let prefix = this.host.trans("imb");
        let suffix = "";
        if (!prefix && ((mid && !mid.startsWith("http")) || !mid)) {
            prefix = "/media/img/";
        }
        if (prefix === "-") {
            prefix = "";
        } else {
            suffix = this.host.get("h") ? "?h=" + this.host.get("h") + "&w=" + this.host.get("w") : "";
        }

        return (prefix || "") + mid + suffix;
    }

    public getSourceType(): string {
        const sourceType = this.host.get("sourceType");
        if (sourceType) {
            return sourceType;
        }

        const src: string = this.host.translate(this.host.get("src"));
        if (src && UImgSourceResolver.isDirectPath(src)) {
            return SOURCE_TYPE_STATIC;
        }

        return SOURCE_TYPE_MEDIA;
    }

    public isStaticSource(): boolean {
        return this.getSourceType() === SOURCE_TYPE_STATIC;
    }

    public static isDirectPath(value: string): boolean {
        return value.startsWith("/")
            || value.startsWith("data:")
            || value.startsWith("blob:")
            || value.startsWith("http");
    }
}
